import React from 'react';
import { Preset } from '@lux/text';
import { Translate } from '@pegasus/translation';
import { useCampaignTimer } from '@browsing/hooks';
import * as S from './styles';
var pad2 = function (number) { return "0".concat(number).slice(-2); };
var TimeLeft = function (_a) {
    var dateTill = _a.dateTill, expireCallback = _a.expireCallback, color = _a.color;
    var _b = useCampaignTimer(dateTill, expireCallback), days = _b.days, hours = _b.hours, minutes = _b.minutes, seconds = _b.seconds;
    return (React.createElement(S.StyledKicker, { title: React.createElement(Translate, { message: "timeLeft.endsIn", raw: true }), titlePreset: Preset.S },
        React.createElement(S.KickerText, { preset: Preset.S, color: color, bold: true, translate: "no" }, days >= 1 ? (React.createElement(Translate, { message: "timeLeft.ticksDayHourFormatShort", params: { days: days, hours: hours, minutes: minutes }, html: true })) : (React.createElement(Translate, { message: "timeLeft.ticksTimerFormatShort", params: {
                hours: hours,
                minutes: pad2(minutes),
                seconds: pad2(seconds),
            }, html: true })))));
};
export default TimeLeft;
